/**
 * QuickCheckInModal Component
 * Modal wrapper for quick check-in submission without navigating away
 */

import React from 'react';
import { Modal, LoadingSpinner } from '../common';
import { CheckInForm } from './CheckInForm';
import { useOKR } from '../../hooks';

interface QuickCheckInModalProps {
  isOpen: boolean;
  onClose: () => void;
  okrId: string;
  okrTitle: string;
  onSuccess?: () => void;
}

export const QuickCheckInModal: React.FC<QuickCheckInModalProps> = ({
  isOpen,
  onClose,
  okrId,
  okrTitle,
  onSuccess
}) => {
  // Fetch full OKR data for the form (need key results)
  const { data: okr, isLoading, error } = useOKR(okrId);

  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Check-in: ${okrTitle}`}
      size="lg"
    >
      {isLoading ? (
        <div className="flex justify-center py-12">
          <LoadingSpinner size="md" text="Loading OKR data..." />
        </div>
      ) : error ? (
        <div className="text-center py-8 text-danger-600">
          <p>Failed to load OKR data. Please try again.</p>
        </div>
      ) : okr ? (
        <div className="max-h-[70vh] overflow-y-auto">
          <CheckInForm
            okr={okr}
            onSuccess={handleSuccess}
            onCancel={onClose}
          />
        </div>
      ) : null}
    </Modal>
  );
};
